import { operateMaxShowLength } from '@/store/dict/config'
import selectOption from '@/store/dict/selectOptionDict'
import { cloneDeep } from 'lodash'
import { CUSTOMER_INFO_TYPE } from '../config/exportConfig'

export default {
  data() {
    return {
      m_headData: [
        {
          name: 'id',
          columnProps: {
            prop: 'id',
            label: '应收ID',
            width: 100,
          },
          render: ({ row }) => {
            if (!this.judgePermission('finance_receivable_detail')) return row.id
            return (
              <span class="a-hover-link" onClick={() => this.viewDetails(row.id)}>
                {row.id}
              </span>
            )
          },
        },
        {
          name: 'content',
          columnProps: {
            prop: 'content',
            label: '收款内容',
          },
          getText: ({ row }) => {
            const vItem = this.freeTypeList.find((item) => item.code === row.content)
            return vItem?.name || ''
          },
        },
        {
          name: 'customer',
          columnProps: {
            prop: 'customer',
            label: '付款方',
            width: 160,
          },
        },
        {
          name: 'plateNo',
          columnProps: {
            prop: 'plateNo',
            label: '车牌号',
            width: 100,
          },
        },
        {
          name: 'receivableDate',
          columnProps: {
            prop: 'receivableDate',
            label: '应收日期',
            width: 100,
          },
        },
        {
          name: 'accruedCycle',
          columnProps: {
            prop: 'accruedCycle',
            label: '款项周期',
            width: 100,
          },
        },
        {
          name: 'rentAmount',
          columnProps: {
            prop: 'rentAmount',
            label: '合同月租金',
            minWidth: 100,
          },
          showEllipsisTooltip: true,
          limitEllipsisLine: 2,
        },
        {
          name: 'itemAmount',
          columnProps: {
            prop: 'itemAmount',
            label: '款项金额',
          },
        },
        {
          name: 'relieveAmount',
          columnProps: {
            prop: 'relieveAmount',
            label: '减免金额',
          },
        },
        {
          name: 'receivableAmount',
          columnProps: {
            prop: 'receivableAmount',
            label: '应收金额',
          },
          getText: ({ row }) => this.numberWithCommas(row.receivableAmount),
        },
        {
          name: 'receivingAmount',
          columnProps: {
            prop: 'receivingAmount',
            label: '收款中金额',
            width: 100,
          },
          getText: ({ row }) => this.numberWithCommas(row.receivingAmount),
        },
        {
          name: 'receivedAmount',
          columnProps: {
            prop: 'receivedAmount',
            label: '已收金额',
          },
          getText: ({ row }) => this.numberWithCommas(row.receivedAmount),
        },
        {
          name: 'remainAmount',
          columnProps: {
            prop: 'remainAmount',
            label: '剩余应收金额',
            width: 120,
          },
          getText: ({ row }) => this.numberWithCommas(row.remainAmount),
        },
        {
          name: 'commissionReceivingAmount',
          columnProps: {
            prop: 'commissionReceivingAmount',
            label: '乾三收款中佣金',
            width: 120,
          },
          getText: ({ row }) => this.numberWithCommas(row.commissionReceivingAmount),
        },
        {
          name: 'commissionReceivedAmount',
          columnProps: {
            prop: 'commissionReceivedAmount',
            label: '乾三已收款佣金',
            width: 120,
          },
          getText: ({ row }) => this.numberWithCommas(row.commissionReceivedAmount),
        },
        {
          name: 'receivableState',
          columnProps: {
            prop: 'receivableState',
            label: '收款状态',
          },
          getText: ({ row }) =>
            selectOption.completionStatusDict[row.receivableState],
        },
        {
          name: 'completeTime',
          columnProps: {
            prop: 'completeTime',
            label: '完成时间',
            width: 160,
          },
        },
        {
          name: 'relReceivableId',
          columnProps: {
            label: '关联单ID',
            prop: 'relReceivableId',
          },
        },
        {
          name: 'customerType',
          columnProps: {
            prop: 'customerType',
            label: '付款方类型',
            width: 100,
          },
          getText: ({ row }) => selectOption.customerTypeDict[row.customerType],
        },
        {
          name: 'customerInfoType',
          columnProps: {
            label: '客户类型',
            prop: 'customerInfoType',
          },
          render: ({ row }) => {
            return CUSTOMER_INFO_TYPE[row?.customerInfoType] || '--'
          },
        },
        {
          name: 'customerId',
          columnProps: {
            prop: 'customerId',
            label: '付款方id',
          },
        },
        {
          name: 'purchaseType',
          columnProps: {
            prop: 'purchaseType',
            label: '采购方式',
          },
        },
        {
          name: 'providerName',
          columnProps: {
            prop: 'providerName',
            label: '车源方',
            width: 160,
          },
        },
        {
          name: 'brandName',
          columnProps: {
            prop: 'brandName',
            label: '品牌',
          },
        },
        {
          name: 'seriesName',
          columnProps: {
            prop: 'seriesName',
            label: '车系',
          },
        },
        {
          name: 'modelName',
          columnProps: {
            prop: 'modelName',
            label: '车型',
            width: 160,
          },
        },
        {
          name: 'sourceOrderType',
          columnProps: {
            prop: 'sourceOrderType',
            label: '来源单类型',
            width: 110,
          },
          getText: ({ row }) =>
            selectOption.sourceOrderTypeDict[row.sourceOrderType],
        },
        {
          name: 'sourceOrderId',
          columnProps: {
            prop: 'sourceOrderId',
            label: '来源单ID',
          },
        },
        {
          name: 'changeState',
          columnProps: {
            prop: 'changeState',
            label: '是否变更',
          },
          getText: ({ row }) => selectOption.isWhetherList[row.changeState],
        },
        {
          name: 'deptName',
          columnProps: {
            prop: 'deptName',
            label: '所属部门',
          },
        },
      ],
      handleList: [
        {
          name: 'addBillDialog',
          label: '线下收款',
          permission: 'finance_receivable_receipt_add',
        },
        {
          name: 'linkReceipt',
          label: '查看收款单',
          permission: 'financeReceiptList',
        },
        {
          name: 'alipayWithhold',
          label: '支付宝支付',
          permission: 'addAlipayReceipt',
        },
        {
          name: 'addChangePlan',
          label: '变更',
          permission: 'finance_receivable_changeReceivable',
        },
        {
          name: 'deductionAmount',
          label: '金额减免',
          permission: 'finance_deductionAmount',
        },
        {
          name: 'completeHandle',
          label: '关闭',
          permission: 'finance_receivable_state',
        },
      ],
      m_paginationData: {
        pageSize: 10,
        pageNum: 1,
        total: 10,
        pageSizes: [5, 10, 20, 50],
      },
    }
  },
  computed: {
    isShowHandle() {
      return this.handleList.some((item) => item.permission)
    },
  },
  created() {
    this.handleList = this.handleList.map((item) => ({
      ...item,
      permission: this.judgePermission(item.permission),
    }))

    if (this.isShowHandle) {
      this.m_headData.push({
        name: 'operate',
        columnProps: {
          label: '操作',
          width: 240,
          fixed: 'right',
        },
        maxShowLength: operateMaxShowLength,
        type: 'operate',
        getOperateList: ({ row }) => {
          return this.getBtnList(row, this.handleList)
        },
      })
    }
  },
  methods: {
    paginationChange(payload) {
      const { pagination } = payload
      this.m_paginationData.pageSize = pagination.pageSize
      this.m_paginationData.pageNum = pagination.pageNum
      this.getReceivableList()
    },
    getBtnList(row, list) {
      const arr = []
      cloneDeep(list).forEach((handle) => {
        const { name, permission } = handle
        if (permission) {
          // 线下收款
          if (
            name === 'addBillDialog' &&
            row.receivableState !== 1 &&
            row.receivableState !== 2 &&
            row.receivedAmount <= Number(row.receivableAmount)
          ) {
            handle.action = () => this[handle.name](row)
            arr.push(handle)
          }
          // 查看收款单
          if (name === 'linkReceipt') {
            handle.action = () => this[handle.name](row.id)
            arr.push(handle)
          }
          // 支付宝支付
          if (name === 'alipayWithhold' && this.moreOption({ row })) {
            handle.action = () => this[handle.name](row)
            arr.push(handle)
          }
          // 变更 relReceivableState=0 滞纳金对应的租金收款内容为 未完成
          if (
            name === 'addChangePlan' &&
            this.bianGeng_button({ row }) &&
            row.relReceivableState !== 0
          ) {
            handle.action = () => this[handle.name](row)
            arr.push(handle)
          }
          // 关闭
          if (name === 'completeHandle' && this.close_button({ row })) {
            handle.action = () => this[handle.name](row)
            arr.push(handle)
          }
          // 减免金额 relReceivableState=0 滞纳金对应的租金收款内容为 未完成
          if (
            name === 'deductionAmount' &&
            row.receivableState === 0 &&
            row.relReceivableState !== 0
          ) {
            handle.action = () => this[handle.name](row)
            arr.push(handle)
          }
        }
      })
      return arr
    },
  },
}
